<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
                  <a-form-model-item prop="duihuanMa" >
                        <span slot="label" ><a-tooltip>{{$t('积分金币兑换码管理.兑换码')}}<template slot="title">{{$t('积分金币兑换码管理.兑换码')}}</template></a-tooltip> </span>
                        <a-input v-model="form.duihuanMa" :maxLength="30" :placeholder="$t('通用.输入.请输入')+'兑换码'" >
                        </a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="duihuanNum" >
                        <span slot="label" ><a-tooltip>{{$t('积分金币兑换码管理.兑换数量')}}<template slot="title">{{$t('积分金币兑换码管理.兑换数量')}}</template></a-tooltip> </span>
                        <a-input-number v-model="form.duihuanNum"  :placeholder="$t('通用.输入.请输入')+'兑换数量'" >
                        </a-input-number>
                  </a-form-model-item>

                <a-form-model-item :label="$t('积分金币兑换码管理.兑换类型')" prop="type" >
                  <a-select :placeholder="$t('通用.输入.请选择')+$t('积分金币兑换码管理.兑换类型')" v-model="form.type" allowClear>
                    <a-select-option v-for="(item, index) in customDict.DuihuanSourceEnum" :value="item.type"
                                     :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                  <a-form-model-item prop="duihuanPeople" >
                        <span slot="label" ><a-tooltip>{{$t('积分金币兑换码管理.最多可兑换人数')}}<template slot="title">{{$t('积分金币兑换码管理.最多可兑换人数')}}</template></a-tooltip> </span>
                        <a-input-number v-model="form.duihuanPeople"  :placeholder="$t('通用.输入.请输入')+'最多可兑换人数'" >
                        </a-input-number>
                  </a-form-model-item>
<!--                  <a-form-model-item prop="duihuanUsedPeople" >-->
<!--                        <span slot="label" ><a-tooltip>{{$t('积分金币兑换码管理.已兑换人数')}}<template slot="title">{{$t('积分金币兑换码管理.已兑换人数')}}</template></a-tooltip> </span>-->
<!--                        <a-input-number v-model="form.duihuanUsedPeople"  :placeholder="$t('通用.输入.请输入')+'已兑换人数'" >-->
<!--                        </a-input-number>-->
<!--                  </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getDuihuan, addDuihuan, updateDuihuan } from '@/api/duihuan/duihuan'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
                          id: null,
                          duihuanMa: null,
                          duihuanNum: null,
                          type: null,
                          duihuanPeople: null,
                          duihuanUsedPeople: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
            duihuanMa: [{ required: true, message: this.$t('积分金币兑换码管理.兑换码')+this.$t('通用.文本.不能为空'), trigger: 'blur' }] ,
            duihuanNum: [{ required: true, message: this.$t('积分金币兑换码管理.兑换数量')+this.$t('通用.文本.不能为空'), trigger: 'blur' }] ,
            type: [{ required: true, message: this.$t('积分金币兑换码管理.兑换类型')+this.$t('通用.文本.不能为空'), trigger: 'blur' }] ,
            duihuanPeople: [{ required: true, message: this.$t('积分金币兑换码管理.最多可兑换人数')+this.$t('通用.文本.不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
                          id: null,
                          duihuanMa: null,
                          duihuanNum: null,
                          type: null,
                          duihuanPeople: null,
                          duihuanUsedPeople: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDuihuan({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateDuihuan(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addDuihuan(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
